__turbopack_context__.v({
  "calloutSection": "PlasmicPricing-module__VU3Q5W__calloutSection",
  "contactModal": "PlasmicPricing-module__VU3Q5W__contactModal",
  "footer": "PlasmicPricing-module__VU3Q5W__footer",
  "header": "PlasmicPricing-module__VU3Q5W__header",
  "pricingProducts": "PlasmicPricing-module__VU3Q5W__pricingProducts",
  "pricingTopSection": "PlasmicPricing-module__VU3Q5W__pricingTopSection",
  "pricingWhySection": "PlasmicPricing-module__VU3Q5W__pricingWhySection",
  "root": "PlasmicPricing-module__VU3Q5W__root",
  "serviceMessage": "PlasmicPricing-module__VU3Q5W__serviceMessage",
});
